module.exports = __webpack_public_path__ + "static/media/wrestling.65b9d18e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/wrestling.svg
// module id = 408
// module chunks = 7